module.exports = __webpack_public_path__ + "static/media/horrormax-banner-vampegeddon.1635349d.jpg";